// extracted by mini-css-extract-plugin
export default {"modalWrapper":"OpenMultiLanguage_modalWrapper__TUYYJ","modalContentWrapper":"OpenMultiLanguage_modalContentWrapper__XOv6I"};